import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { updateDietTiming } from "../../../redux/reducers/putApiSlice";
import { addDietTiming } from "../../../redux/reducers/postApiSlice";
import { selectAuth } from "../../auth/auth.selector";

const DTForm = ({ name, rowData, closeModal, callFunction }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});

  const [startTime, endTime] = rowData?.start_time
    ? rowData.start_time.split("-")
    : ["", ""];

  const iniDTForm = {
    mealTime: name === "edit" && rowData?.name ? rowData.name : "",
    isActive: name === "edit" && rowData?.status === "active" ? true : false,
    startTime: name === "edit" && startTime ? startTime : "",
    endTime: name === "edit" && endTime ? endTime : "",
  };
  const [dtForm, setDTForm] = useState(iniDTForm);
  const [dtFormErrors, setDTFormErrors] = useState();
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value, checked, type } = e.target;

    console.log("type=> ", type);

    setDTForm((prevs) => ({
      ...prevs,
      [name]:
        type === "checkbox" ? checked : type === "time" ? value : value,
    }));
  };

  const validateForm = (dtForm) => {
    let errors = {};

    if (!dtForm.mealTime) {
      errors.mealTime = "Meal Time Is Required!";
    }

    if (!dtForm.startTime) {
      errors.startTime = "Start Time Is Required!";
    }

    if (!dtForm.endTime) {
      errors.endTime = "End Time Is Required!";
    }

    return errors;
  };

  const handleSubmit = () => {
    setDTFormErrors(validateForm(dtForm));
    setIsSubmit(true);
  };

  const handleAdd = async (requestBody, TOKEN) => {
    setIsSubmit(false);

    try {
      const actionResult =
        name === "edit"
          ? dispatch(updateDietTiming({ requestBody, filters: "", TOKEN }))
          : dispatch(addDietTiming({ requestBody, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setDTForm(iniDTForm);
        setDTFormErrors();
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleAddIngredient ERROR => ", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(dtFormErrors)?.length === 0) {
      if (name === "edit") {
        const requestBody = {
          uid: rowData?.uid,
          name: dtForm.mealTime,
          start_time: `${dtForm.startTime}-${dtForm.endTime}`,
          status: dtForm.isActive ? "active" : "inactive",
        };
        handleAdd(requestBody, decryptedText?.token);
      } else {
        const requestBody = {
          name: dtForm.mealTime,
          start_time: `${dtForm.startTime}-${dtForm.endTime}`,
          status: dtForm.isActive ? "active" : "inactive",
        };
        handleAdd(requestBody, decryptedText?.token);
      }
    }
  }, [isSubmit, dtFormErrors]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <div className="createNewCTOModalContainer mealsModalContainer addIngModal">
      <ModalHeadAndClose title="Add meal time" onClose={closeModal} />
      <div className="grayLine"></div>

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox span2">
            <label htmlFor="mealTime" className="formInputLabel">
              Meal Time *
            </label>

            <input
              type="text"
              placeholder="Enter Meal Time"
              className={`formInput ${
                dtFormErrors?.mealTime ? "formError" : ""
              }`}
              name="mealTime"
              value={dtForm.mealTime}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox twoInputs">
            <label htmlFor="timeSlot" className="formInputLabel">
              Select Time Slot *
            </label>

            <div className="commonInputWrapper twoInput">
              <input
                type="time"
                className={`formInput ${
                  dtFormErrors?.startTime ? "formError" : ""
                }`}
                name="startTime"
                value={dtForm.startTime}
                onChange={onChangeInput}
              />
              <span className="to">to</span>
              <input
                type="time"
                className={`formInput ${
                  dtFormErrors?.endTime ? "formError" : ""
                }`}
                name="endTime"
                value={dtForm.endTime}
                onChange={onChangeInput}
              />
            </div>
          </div>

          <div className="formInputBox formInputSwitchAddMore">
            <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                dtFormErrors?.isActive && "formError"
              }`}
            >
              <Form.Check
                type="switch"
                name="isActive"
                label={`${dtForm.isActive ? "Active" : "Inactive for now"}`}
                checked={dtForm.isActive}
                onChange={onChangeInput}
              />
            </div>
          </div>
        </div>

        <div className="formButtons" style={{ justifyContent: "flex-end" }}>
          <Button className="saveBtn" variant="danger" onClick={handleSubmit}>
            add
          </Button>
        </div>
      </form>
    </div>
  );
};

export default DTForm;
